import Vue from 'vue';
import { merge } from 'lodash';

Vue.mixin({
  created() {
    if (!this.eventBus || (typeof this.onProjectChange !== 'function' && typeof this.onNoPermissionForProjectChange !== 'function')) {
      return;
    }
    this.eventBus.$on('global:project-change', this.$$onProjectChange);
  },
  beforeDestroy() {
    this.eventBus.$off('global:project-change', this.$$onProjectChange);
  },
  methods: {
    async $$onProjectChange(id, project) {
      let hasPermission = true;
      const meta = merge({}, this.microRouter?.currentRoute?.meta || {}, this.$route.meta || {});
      hasPermission = this.$store.getters['user/checkAccessPermission'](meta);
      if (!hasPermission) {
        if (typeof this.onNoPermissionForProjectChange === 'function') {
          const r = await this.onNoPermissionForProjectChange(id, project);
          if (r === false) {
            return;
          }
        }
        this.eventBus.$emit('permission-change', false);
      }
      return this.onProjectChange(id, project, hasPermission);
    }
  }
});
